import { ds } from "js/core/models/dataService";
import { Backbone } from "js/vendor";
import Logger from "js/core/logger";
import { app } from "js/namespaces";
import { FeatureType, getUserPlanPermissions, getUserOrgPermissions } from "./planPermissions";
import { getFeatures } from "common/features";

const Features = Backbone.Model.extend({
    defaults: { permissions: Object.freeze({}) },

    initialize: function() {
        // TODO(john): Q: why would this change? if the user upgrades their plan?
        // TODO(john): Q: if the user joins or leaves a team or changes role on a team, we need to update this
        this.listenTo(ds.userPlans, "change", this.loadUserPlanPermissions);
    },

    async loadUserPlanPermissions() {
        this._permissions = {};
        this._permissions["personal"] = await getUserPlanPermissions();

        //ds.teams does not exist for cypress test users
        if (ds.teams && app.user.has("orgs")) {
            for (const orgId of Object.keys(app.user.get("orgs"))) {
                this._permissions[orgId] = await getUserOrgPermissions(orgId);
            }
        }
    },

    // TODO: if these were persisted we'd fetch them in the usual manner
    async loadFakeElectronUserPlanPermissions() {
        this._permissions = {};
        this._permissions["personal"] = getFeatures("pro");

        if (ds.teams && app.user.has("orgs")) {
            for (const orgId of Object.keys(app.user.get("orgs"))) {
                this._permissions[orgId] = getFeatures("member-licensed");
            }
        }
    },

    isFeatureEnabled(feature, workspaceId) {
        if (workspaceId === undefined) {
            throw new Error("missing workspaceId");
        }
        const rv = this._getWorkspaceFeatures(workspaceId).hasOwnProperty(feature);
        return rv;
    },

    getFeatureProps(feature, workspaceId) {
        if (workspaceId === undefined) {
            throw new Error("missing workspaceId");
        }
        const featureProps = this._getWorkspaceFeatures(workspaceId)[feature];
        if (!featureProps) {
            Logger.warn(`${feature} planPermission does not exist for current user. Please check if the ${feature} planPermission is attached to the plan.`);
        }
        return featureProps || {};
    },

    /** @private */
    _getWorkspaceFeatures(workspaceId) {
        if (workspaceId === undefined) {
            throw new Error("missing workspaceId");
        }
        // presentations from external workspaces go into the personal workspace
        const features = this._permissions[workspaceId];
        if (!features) {
            return this._permissions["personal"];
        }
        return features;
    }
});

export { Features, FeatureType };
